import React from "react";
import { SmoothScroll, EnquiryProvider } from "../lib/site-ui";
import { Navbar } from "../components/site/Navbar";
import { Footer } from "../components/site/FaqContact";
import { WhatsAppFloat } from "../components/site/WhatsAppFloat";

export default function PageShell({ children }) {
  return (
    <EnquiryProvider>
      <SmoothScroll />
      <div className="grain" />
      <div className="bg-slate-950 min-h-screen relative">
        <Navbar />
        <main>{children}</main>
        <Footer />
        <WhatsAppFloat />
      </div>
    </EnquiryProvider>
  );
}
